import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
import { StyledButtonContentIcon } from "../blocks";
import { StyledButtonLoader } from "../elements";
export var getButtonContentElementsColor = function getButtonContentElementsColor(color) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n\n  ", " {\n    fill: ", ";\n  }\n\n  ", " {\n    stroke: ", ";\n  }\n"])), color, StyledButtonContentIcon, color, StyledButtonLoader, color);
};